// extracted by mini-css-extract-plugin
module.exports = {"s136w4l7":"s136w4l7"};